var _circle, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMuted(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.5 9.5L11.6467 6.35326C11.7166 6.28342 11.8056 6.23587 11.9026 6.21661C11.9995 6.19736 12.1 6.20726 12.1913 6.24507C12.2826 6.28287 12.3607 6.34689 12.4156 6.42904C12.4705 6.51118 12.4999 6.60777 12.5 6.70659V17.2933C12.4999 17.3921 12.4705 17.4887 12.4156 17.5708C12.3607 17.653 12.2826 17.717 12.1913 17.7548C12.1 17.7926 11.9995 17.8025 11.9026 17.7832C11.8056 17.764 11.7166 17.7164 11.6467 17.6466L8.5 14.5H7.00667C6.42 14.5 5.87067 14.1619 5.71467 13.5973C5.57167 13.0769 5.49947 12.5396 5.5 12C5.5 11.4466 5.57467 10.9113 5.71467 10.4026C5.87067 9.83726 6.42 9.5 7.00667 9.5H8.5Z",
    stroke: "#1A1B1D",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.5 9.5L18.5 12.5M18.5 9.5L15.5 12.5",
    stroke: "#1A1B1D",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMuted);
export default __webpack_public_path__ + "static/media/muted.1efbbfc7f04c57ec3fe95cce934a7e91.svg";
export { ForwardRef as ReactComponent };